export const ROLES = {
    STUDENT: 'student',
    TEACHER: 'teacher',
    MANAGER: 'manager',
    HEADMASTER: 'headmaster',
    ADMIN: 'admin',
};

export const ROLE_GROUPS = {
    // All non-student accounts
    STAFF: [ROLES.TEACHER, ROLES.MANAGER, ROLES.HEADMASTER, ROLES.ADMIN],
    // Accounts with school-admin privileges (mirrors server Constants.js).
    // admin is a super account — manager-level UI, plus the admin-only /panel.
    MANAGERS: [ROLES.MANAGER, ROLES.HEADMASTER, ROLES.ADMIN],
};
